import Vue from "vue";
const http = Vue.prototype.$http;

export async function index(options, params = {}) {
  const { sortBy, sortDesc, page, itemsPerPage } = options;

  const response = await Vue.prototype.$http.get("/clients", {
    params: {
      ...params,
      orderBy: sortBy[0] ? sortBy[0] : "",
      sortDesc: sortDesc[0] ? sortDesc[0] : "",
      page,
      perPage: itemsPerPage
    }
  });

  return response.data;
}

export async function show(id) {
  const response = await Vue.prototype.$http.get("/clients/" + id);

  return response.data;
}

export async function update(id, payload) {
  const response = await Vue.prototype.$http.put("/clients/" + id, payload);

  return response.data;
}

export async function create(payload) {
  const response = await Vue.prototype.$http.post("/clients", payload);

  return response.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete("/clients/" + id);

  return response.data;
}

export async function deleteClientAddress(client_id, address_id) {
  const response = await Vue.prototype.$http.delete(
    `/clients/${client_id}/addresses/${address_id}`
  );

  return response.data;
}

export async function quitarConta(cliente_id, valor) {
  const response = await Vue.prototype.$http.post(
    `/clients/${cliente_id}/quitar_conta`,
    {
      valor
    }
  );

  return response.data;
}

export async function alterarConta(cliente_id, valor) {
  const response = await Vue.prototype.$http.post(
    `/clients/${cliente_id}/alterar_conta`,
    {
      valor
    }
  );

  return response.data;
}
